import { type PlayerProfileResponse } from '@on3/api';
import { Avatar } from '@on3/ui-lib/components/Avatar';
import { Link } from '@on3/ui-lib/components/Link';
import { Pen } from '@on3/ui-lib/components/Svg';
import { useAuth } from '@on3/ui-lib/index';
import { userHasPermission } from '@on3/ui-lib/utils/auth/access';
import { profileAdmin } from '@on3/ui-lib/utils/auth/constants';
import clsx from 'clsx';
import useAthlete from 'contexts/AthleteProvider';

import { StatsMock } from './Mock';
import styles from './PlayerStatsModule.module.scss';

interface PlayerStatsModuleProps {
  player: PlayerProfileResponse;
  className?: string;
  stats?: any[];
}
export const PlayerStatsModule = ({
  player,
  className,
  stats,
}: PlayerStatsModuleProps) => {
  const { athlete } = useAthlete();
  const { user } = useAuth();
  const canEdit = userHasPermission(profileAdmin, user);

  const highSchoolName =
    player.highSchool?.knownAs ??
    player.highSchoolName ??
    player.highSchool?.fullName ??
    '';

  return (
    <section className={clsx(styles.section, className)}>
      <header>
        <figure>
          <Avatar
            domain={player.highSchool?.defaultAsset?.domain}
            height={24}
            source={player.highSchool?.defaultAsset?.source}
            teamAvatar
            width={24}
          />
        </figure>
        <h2>{highSchoolName} High School Stats</h2>
      </header>
      {!stats?.length && (
        <div className={styles.stats}>
          <StatsMock player={player} />
        </div>
      )}
      <div>
        <Link
          className={styles.edit}
          href={
            canEdit
              ? `/db/${athlete.slug}/elite/network/profile/`
              : `/db/${athlete.slug}/claim-profile/`
          }
        >
          <Pen />
          Add Stats
        </Link>
      </div>
    </section>
  );
};
